import { KLAGE_DETAIL } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const klageDetailReducer = (state = {}, action) =>
  CreateNewReducer(state, action, KLAGE_DETAIL, true);

export default klageDetailReducer;
